<template>
  <div class="transport-list-content">
    <div class="transport-list-content-box"
         :style="{background: obj.SHIP_TYPE === 20061002 ? 'rgba(240, 250, 238, 1)':'rgba(237, 244, 250, 1)' }">
      <div class="transport-list-content__detail__button">
        <a-space>
          <dol-button :title="$t('edit')" @click="editTrans(obj)">
            <a-icon type="edit"/>
          </dol-button>
          <dol-button v-if="!obj.children || obj.children.length <= 0" :title="$t('通用_删除')" @click="delNode(obj)">
            <a-icon type="delete"/>
          </dol-button>
          <dol-button v-if="obj.GUID_CODE" @click="downTransFile(obj)"
                      :title="$t('downTransFile')">
            <a-icon type="vertical-align-bottom"/>
          </dol-button>
          <dol-upload :showUploadList="false" @finished="getOrderDetail(masterId)" :paramsData="{
                    SYS_TYPE: 20011003,
                    TARGET_CATE: 20021022,
                    TARGET_TYPE: 20071007,
                    TARGET_ID: obj.SHIP_ID,
                    GUID_CODE: obj.GUID_CODE || ''
                }" serverType="2009">
            <dol-button :title="$t('updateTransFile')">
              <a-icon type="vertical-align-top"/>
            </dol-button>
          </dol-upload>
        </a-space>
      </div>
      <div class="transport-list-content__title">
        <div class="transport-list-content__title-box">
          <div class="transport-list-content__title__city">
            {{ $dt(obj, 'CITY_NAME') }}
          </div>
          <div class="transport-list-content__title__wharf">
            {{ $dt(obj, 'SW_NAME') }}
          </div>
        </div>
        <a-icon class="transport-list-content__title__icon" type="swap-right"/>
        <div class="transport-list-content__title-box">
          <div class="transport-list-content__title__city">{{ $dt(obj, 'D_CITY_NAME') }}</div>
          <div class="transport-list-content__title__wharf">{{ $dt(obj, 'D_SW_NAME') }}</div>
        </div>
      </div>
      <div class="transport-list-content__detail">{{
          obj.SHIP_TYPE === 20061002 ? $t('sweepNumber') : $t('BLNO')
        }}：<span>{{ obj.SHIP_CODE }}</span></div>
      <div v-if="obj.SHIP_TYPE !== 20061002" class="transport-list-content__detail">{{
          $t('vesselVoyage')
        }}：<span>{{ $dt(obj, 'SHIP_NAME') }}</span></div>
      <div class="transport-list-content__detail" v-if="obj.SJ_START_DATE || obj.YJ_START_DATE">{{
          $t('transportStartDate')
        }}：<span>{{ obj.SJ_START_DATE ? $moment(obj.SJ_START_DATE).format('YYYY-MM-DD') : obj.YJ_START_DATE ? `（${$t('expected')}）${$moment(obj.YJ_START_DATE).format('YYYY-MM-DD')}` : '' }}</span>
      </div>
      <div class="transport-list-content__detail" v-if="obj.SJ_END_DATE || obj.YJ_END_DATE">{{
          $t('transportEndDate')
        }}：<span>{{ obj.SJ_END_DATE ? $moment(obj.SJ_END_DATE).format('YYYY-MM-DD') : obj.YJ_END_DATE ? `（${$t('expected')}）${$moment(obj.YJ_END_DATE).format('YYYY-MM-DD')}` : '' }}</span>
      </div>
      <div class="transport-list-content__detail">{{ $t('通用_箱号') }}：
        <a-tag v-for="(item,index) in obj.BOX_CODES?.split(',').slice(0,2)" :key="index">{{ item }}</a-tag>
        <a @click="openBoxModel(obj.BOX_CODES?.split(','))"
           v-if="obj.BOX_CODES?.split(',').length > 2">{{ $t('more') }}</a>
        <dol-button style="margin-left: 4px" @click="editBox(obj)">
          <a-icon type="edit"/>
        </dol-button>
      </div>
      <img v-if="obj.SHIP_TYPE === 20061002" class="transport-list-content__detail__img"
           src="../../../public/static/icon/railway.svg">
      <img v-else class="transport-list-content__detail__img" src="../../../public/static/icon/seaTransBg.svg">
      <a v-if="obj.D_CITY_ID !== orderForm.D_CITY_ID" class="transport-list-content__detail__add__button"
         @click="addFollowUp(obj)">
        {{ $t('addSubsequentTravel') }}
      </a>
    </div>
    <div v-if="obj.children && obj.children.length>0">
      <div style="display: flex;margin-bottom: 24px;">
        <template v-for="item in obj.children">
          <transport-tree :obj="item" :master-id="masterId" :xc-sheet-code="xcSheetCode" :order-form="orderForm"
                          @editTrans="editTrans" @delNode="delNode" @addFollowUp="addFollowUp"
                          @getOrderDetail="getOrderDetail"
                          @editBox="editBox(item)"></transport-tree>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import sheetScript from "@/views/order/orderDetailScript/sheetScript";
import Transport from "@/views/order/transport";

export default {
  name: "transportTree",
  components: {Transport},
  mixins: [sheetScript],
  props: {
    obj: {type: Object},
    masterId: {type: Number},
    xcSheetCode: {type: String},
    orderForm: {type: Object}
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    open() {
      this.transportShow = true
    },
    openBoxModel(boxList) {
      this.$emit('openBoxModel', boxList)
    },
    editTrans(record) {
      this.$emit('editTrans', record, this.masterId)
    },
    delNode(obj) {
      this.$emit('delNode', obj)
    },
    addFollowUp(record) {
      this.$emit('addFollowUp', record, this.masterId)
    },
    getOrderDetail(masterId) {
      this.$emit('getOrderDetail', masterId)
    },
    downTransFile(data) {
      let condition = {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021022",
        "TARGET_TYPE": "20071007",
        "TARGET_ID": data.SHIP_ID
      }
      this.$h5Api({
        type: '2021',
        data: [condition],
      }).then(({data}) => {
        this.$Dolphin.download(data?.FILE_LIST?.[0]?.FILE_NAME, this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
      })
    },
    editBox(record) {
      this.$emit('editBox', record, this.masterId)
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
.transport-list-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;

  .transport-list-content-box {
    padding: 8px 10px 34px 10px;
    border-radius: 5px;
    border: 1px solid rgba(221, 221, 221, 1);
    position: relative;
    margin: 24px 5px 0px 5px;

    .transport-list-content__detail__button {
      text-align: end;
      margin-bottom: 10px;
      position: relative;
      z-index: 1;
    }

    .transport-list-content__title {
      display: flex;
      justify-content: center;
      align-items: center;

      .transport-list-content__title-box {
        text-align: center;

        .transport-list-content__title__city {
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
        }

        .transport-list-content__title__wharf {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
        }
      }

      .transport-list-content__title__icon {
        margin: 0 24px;
        font-size: 20px;
      }
    }

    .transport-list-content__detail {
      margin-top: 24px;
      padding-left: 25%;
      font-size: 12px;
      font-weight: 400;
      color: rgba(135, 135, 135, 1);
      position: relative;
      z-index: 1;

      + .transport-list-content__detail {
        margin-top: 12px;
      }

      span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }

    .transport-list-content__detail__img {
      position: absolute;
      height: 90%;
      width: 39%;
      right: 25px;
      bottom: 0px;
    }


    .transport-list-content__detail__add__button {
      font-size: 12px;
      font-weight: 400;
      color: rgba(31, 108, 186, 1);
      position: absolute;
      right: 10px;
      bottom: 10px;
    }

  }

}


</style>